module.exports = __webpack_public_path__ + "img/mt_clickbait_style_dollar.9f6e2eb3.svg";